import IPageFeature from "../../../models/page/pageComponents/IPageFeature";
import FeatureLayout from "../../../enums/FeatureLayout";
import FeaturesLayout1 from "./FeaturesLayout1";
import FeaturesLayout2 from "./FeaturesLayout2";
import FeaturesLayout3 from "./FeaturesLayout3";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import TitleText from "../../../components/titleText/TitleText";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "row",
        padding: "0 1rem",
        maxWidth: "1200px",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        
        "@media (max-width: 768px)": {
            marginTop: "1rem",
        }
    },
    containerLayout1: {
        flexDirection: "row",

        "@media (max-width: 768px)": {
            flexDirection: "column"
        },
    },
    containerLayout2: {
        flexDirection: "column",

        "@media (max-width: 768px)": {
            flexDirection: "column"
        },
    },
    containerLayout3: {
        flexDirection: "column",

        "@media (max-width: 768px)": {
            padding: "0 1rem"
        },
    }
});

export default function Features(props: IPageFeature) {
    const styles = useStyles();

    let containerStyle = styles.container,
        titleAlignment: "center" | "start" = "start",
        titleWidth = "80%";

    switch (props.featureStyle) {
        case FeatureLayout.LAYOUT1:
            titleWidth = "40%";
            containerStyle = mergeClasses(styles.container, styles.containerLayout1);
            break;
        case FeatureLayout.LAYOUT2:
            containerStyle = mergeClasses(styles.container, styles.containerLayout2);
            titleAlignment = "center";

            break;
        case FeatureLayout.LAYOUT3:
            containerStyle = mergeClasses(styles.container, styles.containerLayout3);
            titleAlignment = "center";

            break;
        default:
            break;
    }

    return (
        <div className={containerStyle}>
            <TitleText
                title={props.title}
                titleHighlightedWords={props.titleHighlightedWords}
                subtitle={props.description}
                alignment={titleAlignment}
                width={titleWidth}
                />
            
            {
                {
                    [FeatureLayout.LAYOUT1]: <FeaturesLayout1 {...props} />,
                    [FeatureLayout.LAYOUT2]: <FeaturesLayout2 {...props} />,
                    [FeatureLayout.LAYOUT3]: <FeaturesLayout3 {...props} />
                }[props.featureStyle]
            }
        </div>
    );
}